import { createFileRoute } from "@tanstack/react-router";
import { ArticlesHub } from "@/components/marketing/ArticlesHub";
import { HUB_DICT_VI } from "@/lib/articles.dict";
import { getArticlesTree } from "@/lib/articles.functions";

const SITE_URL = "https://banana.cards";

export const Route = createFileRoute("/vi/articles/")({
  loader: () => getArticlesTree({ data: { locale: "vi" } }),
  component: RouteComponent,
  head: () => ({
    meta: [
      { title: "Bài viết — Cẩm nang bán hàng & kết nối · Banana Cards" },
      { name: "description", content: "Bài viết chuyên sâu về tìm kiếm khách hàng, chiến lược CRM, cold outreach và xây dựng mạng lưới — do đội ngũ Banana Cards viết." },
      { property: "og:title", content: "Banana Cards Articles — Cẩm nang bán hàng hiện đại" },
      { property: "og:description", content: "Hướng dẫn chuyên sâu về tìm kiếm khách hàng bằng AI, chiến lược CRM và chốt nhiều đơn hơn với Banana Cards." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/vi/articles` },
      { property: "og:locale", content: "vi" },
      { property: "og:locale:alternate", content: "en" },
      { name: "robots", content: "index,follow" },
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/vi/articles` },
      { rel: "alternate", hreflang: "en", href: `${SITE_URL}/articles` },
      { rel: "alternate", hreflang: "vi", href: `${SITE_URL}/vi/articles` },
      { rel: "alternate", hreflang: "x-default", href: `${SITE_URL}/articles` },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Bài viết Banana Cards — Cẩm nang bán hàng & kết nối",
          description: "Bài viết chuyên sâu về tìm kiếm khách hàng, chiến lược CRM, cold outreach và xây dựng mạng lưới — do đội ngũ Banana Cards viết.",
          url: `${SITE_URL}/vi/articles`,
          isPartOf: { "@type": "WebSite", name: "banana.cards", url: SITE_URL },
        }),
      },
    ],
  }),
});

function RouteComponent() {
  const initialData = Route.useLoaderData();
  return <ArticlesHub locale="vi" dict={HUB_DICT_VI} initialData={initialData} />;
}